// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__2j_36","noSeries":"styles_noSeries__ttk4m"};